import { render, staticRenderFns } from "./Monto.vue?vue&type=template&id=6ea17232&"
import script from "./Monto.vue?vue&type=script&lang=js&"
export * from "./Monto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports